import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subject-regimes',
  templateUrl: './subject-regimes.component.html',
  styleUrls: ['./subject-regimes.component.css']
})
export class SubjectRegimesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
